export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/opt/build/repo/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:catchall(.*)',
    name: '/[...catchall]',
    component: () => import('/opt/build/repo/src/pages/[...catchall].vue'),
    /* no children */
    meta: {
      "layout": "AuthLayout"
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/build/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "AuthLayout"
    }
  },
  {
    path: '/playground',
    name: '/playground',
    component: () => import('/opt/build/repo/src/pages/playground.vue'),
    /* no children */
  },
  {
    path: '/projects',
    /* internal name: '/projects' */
    /* no component */
    children: [
      {
        path: '',
        name: '/projects/',
        component: () => import('/opt/build/repo/src/pages/projects/index.vue'),
        /* no children */
      },
      {
        path: ':project',
        /* internal name: '/projects/[project]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/projects/[project]/',
            component: () => import('/opt/build/repo/src/pages/projects/[project]/index.vue'),
            /* no children */
          },
          {
            path: ':page',
            /* internal name: '/projects/[project]/[page]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/projects/[project]/[page]/',
                component: () => import('/opt/build/repo/src/pages/projects/[project]/[page]/index.vue'),
                /* no children */
              },
              {
                path: ':subpage',
                name: '/projects/[project]/[page]/[subpage]',
                component: () => import('/opt/build/repo/src/pages/projects/[project]/[page]/[subpage].vue'),
                /* no children */
              }
            ],
          },
          {
            path: ':page(.*)',
            name: '/projects/[project]/[...page]',
            component: () => import('/opt/build/repo/src/pages/projects/[project]/[...page].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

